import { render, staticRenderFns } from "./ReOtp.vue?vue&type=template&id=a2d127be&scoped=true"
import script from "./ReOtp.vue?vue&type=script&lang=js"
export * from "./ReOtp.vue?vue&type=script&lang=js"
import style0 from "./ReOtp.vue?vue&type=style&index=0&id=a2d127be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d127be",
  null
  
)

export default component.exports